import { connect } from 'react-redux';
import Credentials from './Credentials';
import { IProfileState } from '../../redux';

const mapStateToProps = (state: IProfileState) => ({
  credentials: state.profile.credentials.list.items,
  isLoading: state.profile.credentials.list.isLoading,
  error: state.profile.credentials.list.error,
});

export default connect(mapStateToProps, null)(Credentials);
